import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { Alert } from '@biome-design-system/ui/Alert';
import { FormattedMessage } from '@kyruus/intl';
import Banner from '@kyruus/banner';
import { ButtonLink } from '@kyruus/button';
import { BannerContainer, NoResultsInSearchAreaContainer } from './styles';
import {
  MAPS_PROVIDER_DRAWER_NO_RESULT,
  MAPS_PROVIDER_DRAWER_LOADING_ERROR,
  SEARCH_THIS_AREA_NO_RESULTS
} from '../../lib/constants';

const renderStartNewSearchLink = (linkText, history) => {
  return (
    <ButtonLink
      mode="flat"
      onClick={(e) => {
        e.preventDefault();
        history.push('/');
      }}
      className="actionLink"
    >
      <FormattedMessage {...linkText} />
    </ButtonLink>
  );
};

const renderGoBackToSearchResultsLink = (
  backToSearchUrl,
  linkText,
  history
) => {
  return (
    <ButtonLink
      mode="flat"
      onClick={(e) => {
        e.preventDefault();
        history.push(backToSearchUrl);
      }}
      className="actionLink"
    >
      <FormattedMessage {...linkText} />
    </ButtonLink>
  );
};

const renderTryAgainLink = (linkText) => {
  return (
    <ButtonLink
      mode="flat"
      onClick={(e) => {
        e.preventDefault();
        window.location.reload();
      }}
      className="actionLink"
    >
      <FormattedMessage {...linkText} />
    </ButtonLink>
  );
};

const NoResultsBanner = ({
  messages,
  showBackToSearchResultLink,
  backToSearchUrl,
  hasNoMlocData,
  log,
  history,
  ...props
}) => {
  useEffect(() => {
    // tracking on load of banner i.e no results or loading error
    log(MAPS_PROVIDER_DRAWER_NO_RESULT);
  }, []);

  const errorMsg = hasNoMlocData
    ? messages.noMlocDataMapsProviderBannerMsg
    : messages.noResultMapsProviderBannerMsg;

  return (
    <BannerContainer data-testid="mapsProviderNoResultsBanner" {...props}>
      <Banner type="info" icon="!">
        <FormattedMessage
          {...errorMsg}
          values={{
            startNewSearch: renderStartNewSearchLink(
              messages.noResultMapsProviderBannerNewSearchLink,
              history
            ),
            backToSearchResult: showBackToSearchResultLink
              ? renderGoBackToSearchResultsLink(
                  backToSearchUrl,
                  messages.noResultMapsGoBackToListPageLink,
                  history
                )
              : null
          }}
        />
      </Banner>
    </BannerContainer>
  );
};

const ErrorBanner = ({ messages, log, history, ...props }) => {
  useEffect(() => {
    // tracking on load of banner i.e no results or loading error
    log(MAPS_PROVIDER_DRAWER_LOADING_ERROR);
  }, []);

  return (
    <BannerContainer data-testid="mapsProviderErrorBanner" {...props}>
      <Banner type="warning" icon="!">
        <FormattedMessage
          {...messages.loadingErrorMapsProviderBannerMsg}
          values={{
            startNewSearch: renderStartNewSearchLink(
              messages.noResultMapsProviderBannerNewSearchLink,
              history
            ),
            pleaseTryAgain: renderTryAgainLink(
              messages.loadingErrorMapsProviderBannerTryAgainLink
            )
          }}
        />
      </Banner>
    </BannerContainer>
  );
};

const NoResultsInSearchArea = ({ messages, log }) => {
  useEffect(() => {
    // tracking on load of banner i.e no results
    log(SEARCH_THIS_AREA_NO_RESULTS);
  }, []);

  return (
    <NoResultsInSearchAreaContainer>
      <Alert
        severity="warning"
        variant="outlined"
        data-testid="no-results-banner"
      >
        <FormattedMessage {...messages.noResultsBanner} />
      </Alert>
    </NoResultsInSearchAreaContainer>
  );
};

NoResultsBanner.propTypes = {
  messages: PropTypes.object.isRequired,
  log: PropTypes.func.isRequired
};

ErrorBanner.propTypes = {
  messages: PropTypes.object.isRequired,
  log: PropTypes.func.isRequired
};

const MapsNoResultsBanner = withRouter(NoResultsBanner);
const MapsErrorBanner = withRouter(ErrorBanner);

export { MapsNoResultsBanner, MapsErrorBanner, NoResultsInSearchArea };
